{
  "hero": {
    "statusBadge": "Available for new opportunities",
    "availabilityTimeline": "Available in 1–2 weeks",
    "preferredRoles": [
      "Senior Front-end Engineer (Web & Mobile)",
      "Senior Full-stack Engineer"
    ],
    "title": "I build software that",
    "titleAccent": "drives business results",
    "subtitle": "Senior Software Engineer with 6+ years of experience building scalable web applications, leading engineering teams, and delivering products that generate millions in revenue.",
    "ctaText": "Schedule a Call",
    "ctaLink": "https://cal.com/kostiantyn-tarasenko/30min",
    "secondaryCtaText": "View My Work",
    "secondaryCtaLink": "/portfolio",
    "resumeButtonText": "Resume",
    "resumeDownloadsText": "downloads",
    "trustLabel": "TRUSTED BY ENGINEERING TEAMS AT",
    "trustCompanies": [
      "Capgemini Engineering",
      "Bupa",
      "Riyadh Municipality"
    ],
    "backgroundVideo": "/hero-bg.mp4"
  },
  "home": {
    "stats": [
      {
        "label": "Users Served",
        "value": "10M+",
        "tooltip": "Bupa — 5M+ insured customers (UK)\nRiyadh Municipality — 4M+ residents served\nPivo — 500K+ creators & athletes\nOther products — 500K+ combined"
      },
      {
        "label": "Industries",
        "value": "5",
        "tooltip": "Healthcare — Bupa (UK's largest health insurer)\nGovernment — Riyadh Municipality (citizen services)\nAI / Computer Vision — Pivo (auto-tracking cameras)\nSustainability — Greenbin (waste management)\nFintech — payment & lending products"
      },
      {
        "label": "Projects Delivered",
        "value": "20+",
        "tooltip": "From early-stage startups to enterprise platforms — full case studies with achievements, tech stacks and outcomes.",
        "tooltipLink": {
          "label": "See all projects",
          "href": "/portfolio"
        }
      },
      {
        "label": "Years of Experience",
        "value": "6+"
      }
    ],
    "featuredProjectsTitle": "Featured Projects",
    "viewAllProjectsText": "View all projects",
    "featuredProjectsSubtitle": "A selection of projects that demonstrate real business impact.",
    "testimonialsTitle": "What People Say",
    "testimonialsSubtitle": "Feedback from colleagues and clients I have worked with.",
    "blogTitle": "Latest Articles",
    "viewAllBlogText": "Read all articles",
    "blogSubtitle": "Thoughts on engineering, architecture, and building great software.",
    "ctaTitle": "Let's work together",
    "ctaSubtitle": "Looking for a senior engineer who delivers results? Let's have a conversation about how I can help your team.",
    "ctaButtonText": "Get in Touch",
    "ctaResumeText": "Download Resume",
    "upwork": {
      "enabled": true,
      "profileUrl": "https://www.upwork.com/freelancers/~01d6cc28449bba5b3c",
      "headline": "Excellence delivered, project after project",
      "subtitle": "Verified results from clients I have worked with on Upwork",
      "rating": 5,
      "reviewCount": 17,
      "badgeEnabled": false,
      "badge": "Top Rated",
      "stats": [
        {
          "label": "Jobs completed",
          "value": "16"
        },
        {
          "label": "Repeat client rate",
          "value": "33%"
        },
        {
          "label": "On-time delivery",
          "value": "97%"
        }
      ],
      "ctaText": "View my Upwork profile"
    }
  },
  "about": {
    "label": "About Me",
    "title": "Engineer who turns complex problems into",
    "titleAccent": "elegant solutions",
    "photo": "https://jfonbsfznnzdl5kb.public.blob.vercel-storage.com/store/1779471697934-aleksei-ieshkin-A6obuTm7_z0-unsplash.jpg",
    "bio": [
      "I'm a Senior Software Engineer with over 6 years of experience building web and mobile apps using modern technologies. My work spans from early-stage startups to enterprise-scale platforms, always focused on delivering measurable business impact through thoughtful engineering.",
      "I specialize in React, React Native and TypeScript on the frontend, with deep experience in backend systems using Node.js. I have led teams, architected distributed systems, and shipped products used by millions.",
      "Beyond writing code, I care deeply about engineering culture — mentoring developers, establishing best practices, and building teams that ship with confidence and velocity."
    ],
    "scheduleCallText": "Schedule a Call",
    "downloadResumeText": "Download Resume",
    "resumeLink": "/resume.pdf",
    "quickFactsTitle": "Quick Facts",
    "quickFacts": [
      {
        "label": "Location",
        "value": "Warsaw, Poland (remote preferred)"
      },
      {
        "label": "Experience",
        "value": "6+ years"
      },
      {
        "label": "Specialization",
        "value": "Front-end & Full-stack (Web + Mobile)"
      },
      {
        "label": "Focus",
        "value": "React, React Native, TypeScript, Node.js"
      },
      {
        "label": "Status",
        "value": "Open for new opportunities"
      },
      {
        "label": "Available from",
        "value": "1-2 weeks"
      },
      {
        "label": "Education",
        "value": "Computer Science, Odesa Professional College"
      }
    ],
    "philosophyTitle": "Engineering Philosophy",
    "values": [
      {
        "title": "AI Engineering",
        "description": "I leverage AI tools and LLMs on daily basis to accelerate development and automate routine tasks."
      },
      {
        "title": "Impact First",
        "description": "Every technical decision should drive business outcomes. I focus on what moves the needle."
      },
      {
        "title": "Team Multiplier",
        "description": "I make the people around me better through mentoring, code reviews, and knowledge sharing."
      },
      {
        "title": "Continuous Growth",
        "description": "Technology evolves fast. I stay ahead by constantly learning and experimenting with new tools."
      }
    ],
    "skillsTitle": "Technical Skills",
    "skills": {
      "Frontend": [
        "React",
        "React Native",
        "Expo",
        "TypeScript",
        "Redux",
        "redux-saga",
        "react-query",
        "Next.js",
        "TanStack Query",
        "Vite",
        "Stripe"
      ],
      "Mobile": [
        "React Native",
        "Flutter",
        "flutter_bloc",
        "Firebase",
        "App Center",
        "Shorebird",
        "Fastlane",
        "Stallion",
        "OneSignal",
        "RevenueCat",
        "Mixpanel",
        "Amplitude"
      ],
      "Backend": [
        "Node.js",
        "Express.js",
        "Ruby on Rails",
        "Apollo GraphQL",
        "REST APIs",
        "WebSocket",
        "Redis",
        "gRPC"
      ],
      "Infrastructure": [
        "AWS",
        "Azure DevOps",
        "Docker",
        "Jenkins",
        "Kubernetes",
        "AWS Lambda",
        "Nginx",
        "CI/CD"
      ],
      "Data & AI": [
        "PostgreSQL",
        "MongoDB",
        "Apache Kafka",
        "Sentry",
        "Kibana",
        "OpenAI APIs",
        "RAG",
        "Vector Databases",
        "LangChain",
        "Embeddings",
        "BigQuery"
      ],
      "Testing": [
        "Jest",
        "React Testing Library",
        "Cypress",
        "Selenium WebDriver",
        "Firebase Test Lab"
      ],
      "Visualization": [
        "D3.js",
        "Three.js",
        "Highcharts.js",
        "Canvas API"
      ]
    },
    "ctaTitle": "Interested in working together?",
    "ctaButtonText": "Get in Touch"
  },
  "experience": {
    "label": "Career",
    "title": "Professional Experience",
    "subtitle": "A track record of delivering high-impact software across startups and enterprise companies. Each role focused on measurable outcomes — not just responsibilities.",
    "experienceEmptyText": "No experience entries yet — stay tuned!",
    "downloadResumeText": "Download Full Resume",
    "discussButtonText": "Discuss My Experience",
    "bottomText": "Want to know more about a specific role?",
    "bottomButtonText": "Let's Talk"
  },
  "projects": {
    "label": "Portfolio",
    "title": "Projects",
    "subtitle": "Each project highlights technical decisions, architecture, and measurable business outcomes — not just features shipped.",
    "projectsEmptyText": "No projects yet — stay tuned!",
    "filterTypeLabel": "Type",
    "filterIndustryLabel": "Industry",
    "filterEngagementLabel": "Engagement",
    "filterAllText": "All",
    "filterFreelanceText": "Freelance",
    "filterNonFreelanceText": "Non-freelance",
    "backToPortfolioText": "Back to Portfolio"
  },
  "blog": {
    "label": "Blog",
    "title": "Articles & Insights",
    "subtitle": "Practical engineering knowledge from building real-world applications at scale. No fluff, just lessons learned.",
    "blogEmptyText": "No posts yet — stay tuned!",
    "rssTooltip": "Subscribe via RSS",
    "backToBlogText": "Back to Blog",
    "relatedArticlesTitle": "Related Articles",
    "articleCtaButton": "Get in Touch",
    "articleCtaText": "Enjoyed this article? Let's connect.",
    "likeHintText": "Useful info? Like this post!",
    "likeHintSubtext": "It supports me to share more.",
    "likeThankYouText": "Thanks for the like! 🙏",
    "subscribeTitle": "Get notified about new articles",
    "subscribeSubtitle": "No spam, unsubscribe anytime.",
    "subscribePlaceholder": "your@email.com",
    "subscribeButtonText": "Subscribe",
    "subscribeSuccessTitle": "You're subscribed!",
    "subscribeSuccessSubtitle": "I'll send you an email when new articles are published.",
    "subscribeAlreadyText": "You're already subscribed!",
    "subscribeErrorText": "Failed to subscribe. Please try again.",
    "subscribeInvalidEmail": "Please enter a valid email"
  },
  "store": {
    "label": "Services",
    "title": "Engineering services",
    "subtitle": "Pick a service, pick a plan, and we ship. Real engineering work for teams that want to skip the agency overhead and talk straight to the person writing the code.",
    "storeEmptyText": "No services listed yet — check back soon.",
    "backToStoreText": "Back to Services",
    "buyNowText": "Book this plan",
    "engagementsDeliveredLabel": "engagements delivered",
    "viewPlansText": "View plans",
    "plansCountLabel": "plans",
    "fromLabel": "from",
    "startsAtLabel": "starts at",
    "extrasNote": "+ extras priced separately",
    "extrasNoteShort": "+ extras",
    "incVatText": "incl. VAT",
    "pickPlanPrompt": "Pick a plan above to continue",
    "selectedLabel": "Selected",
    "chooseThisPlanText": "Choose this plan",
    "mostPopularText": "Most popular",
    "bookingModal": {
      "title": "Book the {plan} plan",
      "subtitle": "I'll reply within one business day to set up a discovery call.",
      "nameLabel": "Your name",
      "namePlaceholder": "Jane Smith",
      "nameRequired": "Please enter your name",
      "emailLabel": "Email",
      "emailPlaceholder": "you@company.com",
      "emailRequired": "Please enter your email",
      "emailInvalid": "Please enter a valid email",
      "companyLabel": "Company (optional)",
      "companyPlaceholder": "Acme Inc.",
      "phoneLabel": "Phone (optional)",
      "phonePlaceholder": "+1 555 123 4567",
      "timelineLabel": "Timeline",
      "timelinePlaceholder": "When would you like to start?",
      "timelineOptions": [
        { "value": "asap", "label": "ASAP — within 2 weeks" },
        { "value": "1-month", "label": "Within a month" },
        { "value": "1-3-months", "label": "1–3 months out" },
        { "value": "flexible", "label": "Flexible — no rush" }
      ],
      "briefLabel": "Project brief",
      "briefPlaceholder": "What are you building? Who is it for? Any specific tech preferences or hard constraints?",
      "briefRequired": "Tell me a few words about your project",
      "extrasLabel": "Add-ons / extras",
      "extrasHint": "(optional, priced separately)",
      "extrasPlaceholder": "Mobile app version, i18n, advanced analytics dashboard, custom integrations, etc.",
      "submitText": "Send booking request",
      "disclaimerText": "No payment yet — you'll get a discovery call first and a tailored quote before any commitment.",
      "successTitle": "Booking sent",
      "successSubtitle": "Thanks — I've got your request for the {plan} plan. I'll reply within one business day to set up a discovery call and walk you through the engagement.",
      "closeText": "Close",
      "errorMessage": "Something went wrong. Try again?"
    }
  },
  "contact": {
    "label": "Contact",
    "title": "Let's Talk",
    "subtitle": "Whether you have a role in mind, a project to discuss, or just want to connect — I would love to hear from you.",
    "email": "konstantin.tarasenko.work@gmail.com",
    "calendlyLink": "https://cal.com/kostiantyn-tarasenko/30min",
    "githubLink": "https://github.com/kostyatarasenko",
    "linkedinLink": "https://linkedin.com/in/kostiantyn-tarasenko",
    "emailLabel": "Email",
    "locationLabel": "Location",
    "locationValue": "Warsaw, Poland",
    "socialTitle": "Connect on Social",
    "calendlyCardTitle": "Prefer a quick call?",
    "calendlyButtonText": "Schedule a call",
    "calendlyCardSubtitle": "Book a 15-minute intro call — no commitment, just a conversation.",
    "formTitle": "Send a message",
    "formSubtitle": "I typically respond within 24 hours.",
    "formNameLabel": "Name",
    "formNamePlaceholder": "Your name",
    "formEmailLabel": "Email",
    "formEmailPlaceholder": "your@email.com",
    "formMessageLabel": "Message",
    "formMessagePlaceholder": "Tell me about your project, role, or how I can help...",
    "formMessageExamples": [
      "Hi! We're hiring a Senior Engineer at Stripe — open to a chat?",
      "Need help shipping our React Native app to production by Q3.",
      "Looking for a tech lead for an early-stage fintech startup.",
      "Want to migrate our legacy WebView features to native — 2 month engagement.",
      "Hey, we loved your Pivo work — got a similar project, can we talk?"
    ],
    "formSubmitText": "Send Message",
    "formEmailDirectly": "Or email directly:",
    "formSuccessMessage": "Message sent! I will get back to you shortly.",
    "formErrorMessage": "Something went wrong. Please try email instead.",
    "availabilityBadge": "Available · Replies within 24h",
    "howItWorksTitle": "How it works",
    "howItWorksSteps": [
      {
        "title": "Send a message",
        "description": "A short note about your project, role or idea — no formality needed."
      },
      {
        "title": "Reply within 24 hours",
        "description": "I personally read every message. You'll hear back on the same business day."
      },
      {
        "title": "Quick call to align",
        "description": "If it's a fit, we hop on a 30-min call to scope and figure out the next step."
      }
    ],
    "trustBadges": [
      { "icon": "shield", "text": "No spam — your email is never shared" },
      { "icon": "clock", "text": "Average response: 6 hours" },
      { "icon": "check", "text": "100% reply rate this year" }
    ]
  },
  "notFound": {
    "title": "Page not found",
    "subtitle": "The page you're looking for doesn't exist or has been moved. Let's get you back on track.",
    "goHomeText": "Go Home",
    "goBackText": "Go Back"
  },
  "navbar": {
    "brand": "KT",
    "brandFull": "Kostiantyn Tarasenko",
    "drawerTitle": "Navigation",
    "items": [
      {
        "label": "Home",
        "key": "/"
      },
      {
        "label": "About Me",
        "key": "/about-me"
      },
      {
        "label": "Career",
        "key": "/career"
      },
      {
        "label": "Portfolio",
        "key": "/portfolio"
      },
      {
        "label": "Blog",
        "key": "/blog"
      },
      {
        "label": "Services",
        "key": "/services"
      },
      {
        "label": "Contact",
        "key": "/contact"
      }
    ]
  },
  "footer": {
    "brand": "KT",
    "navigationTitle": "Navigation",
    "bio": "Senior Software Engineer crafting scalable, high-performance applications. Open to new opportunities.",
    "connectTitle": "Connect",
    "copyright": "All rights reserved.",
    "builtWith": "Built with React, TypeScript & Ant Design"
  },
  "resumeModal": {
    "title": "Thank you for downloading my resume!",
    "subtitle": "Have a role in mind? Leave your email and I'll follow up about your opportunity",
    "placeholder": "your@email.com",
    "submitText": "Send",
    "successTitle": "Got it!",
    "successSubtitle": "I'll get back to you at {email} shortly",
    "doneText": "Done",
    "errorMessage": "Something went wrong. Please try again."
  },
  "validation": {
    "nameRequired": "Please enter your name",
    "emailRequired": "Please enter your email",
    "emailInvalid": "Please enter a valid email",
    "messageRequired": "Please enter a message"
  },
  "meta": {
    "siteTitle": "Kostiantyn Tarasenko — Senior Software Engineer",
    "siteDescription": "Personal website and portfolio of Kostiantyn Tarasenko, a Senior Software Engineer specializing in React, TypeScript, and scalable web applications.",
    "ogImage": "/og-image.png"
  }
}
